import { render, staticRenderFns } from "./AutomaticMergeIcon.vue?vue&type=template&id=50416469&"
import script from "./AutomaticMergeIcon.vue?vue&type=script&lang=js&"
export * from "./AutomaticMergeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports